export enum SortOrder {
  LATEST = 'LATEST',
  RATING = 'RATING',
  TITLE = 'TITLE',
  POPULARITY = 'POPULARITY',
  YEAR = 'YEAR'
}
